import { Approach } from 'src/features/well-form/entities/approach-entities';
import { IFormEvents } from 'src/features/well-form/entities/form.entity';
import { EventBus } from 'src/shared/utils/event-bus';
import { Directories } from 'src/store/directories/directories.store';

import {
  TApproachRaw,
  TApproachStageRaw,
  TItemRaw,
  TSavedFormItems,
  TSerializedRigOperation,
  TSerializedStage,
} from '../../types';
import { mapItems } from '../common-serializers';

type Options = {
  approachReference: TApproachRaw;
  directories: Directories;
  eventBus: EventBus<IFormEvents>;
};

export const mapApproach = (
  { approachReference, directories, eventBus }: Options,
  savedApproach?: TSerializedRigOperation,
): Approach => {
  const savedFields: TSavedFormItems = {};
  let savedStages: TSerializedStage[] | undefined = undefined;

  const fields: TItemRaw[] = [];
  const stageReference: TApproachStageRaw | undefined = approachReference.stageTemplate.stage;

  for (const item of approachReference.items) {
    fields.push(item);
  }

  for (const key in savedApproach) {
    if (!key.includes('stages')) {
      savedFields[key] = savedApproach[key];
    }
    if (key.includes('stages')) {
      const stages = savedApproach[key];
      if (Array.isArray(stages)) {
        savedStages = stages;
      }
    }
  }

  const data = {
    id: savedApproach?.['GOplan_RigOperation.id'] || savedApproach?.id,
    fields: mapItems(fields, directories, savedFields),
    stageReference,
    approachReference,
    savedStages,
    directories,
    indexAttrName: approachReference.indexAttrName,
    rigOperationIdAttrName: approachReference.rigOperationIdAttrName,
    rawApproach: savedApproach,
  };

  return new Approach(data, eventBus);
};
